// // frontend/src/pages/Dashboard/Customer/All/components/CustomerTable/CustomerTable.jsx

// import React, { useState, useEffect } from 'react';
// import * as XLSX from 'xlsx';
// import { customerApi } from '../../../../api/customer/customerApi';
// import styles from './CustomerTable.module.css';

// const CustomerTable = ({ onCustomerClick, savedState }) => {
//   const [customers, setCustomers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState(savedState?.searchTerm || '');
//   const [currentPage, setCurrentPage] = useState(savedState?.currentPage || 1);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalItems, setTotalItems] = useState(0);
//   const itemsPerPage = 20;

//   // Function to get current table state
//   const getCurrentTableState = () => ({
//     currentPage,
//     searchTerm
//   });

//   // Handle customer click
//   const handleCustomerClick = (customerCode) => {
//     if (onCustomerClick) {
//       onCustomerClick(customerCode, getCurrentTableState());
//     }
//   };

//   // Fetch customers
//   const fetchCustomers = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const data = await customerApi.getCustomers(currentPage - 1, itemsPerPage, searchTerm);
//       setCustomers(data.customers);
//       setTotalPages(data.totalPages);
//       setTotalItems(data.totalItems);
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to fetch customers');
//       console.error('Error fetching customers:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch on mount and when page/search changes
//   useEffect(() => {
//     fetchCustomers();
//   }, [currentPage, searchTerm]);

//   // Handle search
//   const handleSearch = () => {
//     setCurrentPage(1);
//     fetchCustomers();
//   };

//   // Handle clear filters
//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   // Handle Excel export
//   const handleExportExcel = async () => {
//     try {
//       setLoading(true);
//       const exportData = await customerApi.exportCustomers(searchTerm);
      
//       const worksheet = XLSX.utils.json_to_sheet(exportData.map(customer => ({
//         'Customer Code': customer.customerCode,
//         'Customer Name': customer.customerName,
//         'Phone': customer.phone || 'N/A',
//         'Email': customer.email || 'N/A'
//       })));

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Customers');
//       XLSX.writeFile(workbook, `customers_${new Date().toISOString().split('T')[0]}.xlsx`);
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to export customers');
//       console.error('Error exporting customers:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={styles.wrapper}>
//       {/* Filters Section */}
//       <div className={styles.filtersSection}>
//         <div className={styles.searchRow}>
//           <div className={styles.searchInputWrapper}>
//             <span className={styles.searchIcon}>🔍</span>
//             <input
//               type="text"
//               className={styles.searchInput}
//               placeholder="Search customers..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//             />
//           </div>
//           <button 
//             className={styles.searchButton}
//             onClick={handleSearch} 
//             disabled={loading}
//           >
//             {loading ? 'Searching...' : 'Search'}
//           </button>
//         </div>

//         <div className={styles.filterRow}>
//           <div className={styles.actionButtons}>
//             <button 
//               className={styles.clearButton}
//               onClick={handleClearFilters} 
//               disabled={loading}
//             >
//               Clear Filters
//             </button>
//             <button 
//               className={styles.excelButton}
//               onClick={handleExportExcel} 
//               disabled={loading}
//             >
//               <span className={styles.excelIcon}>📊</span>
//               Export Excel
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className={styles.errorMessage}>
//           <span className={styles.errorIcon}>⚠️</span>
//           {error}
//         </div>
//       )}

//       {/* Desktop Table View */}
//       <div className={styles.desktopTableContainer}>
//         <div className={styles.tableWrapper}>
//           <table className={styles.table}>
//             <thead>
//               <tr>
//                 <th className={styles.th}>Customer Code</th>
//                 <th className={styles.th}>Customer Name</th>
//                 <th className={styles.th}>Phone</th>
//                 <th className={styles.th}>Email</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr className={styles.tr}>
//                   <td className={styles.td} colSpan="4" style={{ textAlign: 'center', padding: '40px' }}>
//                     <div className={styles.loadingSpinner}>Loading...</div>
//                   </td>
//                 </tr>
//               ) : customers.length > 0 ? (
//                 customers.map((customer, index) => (
//                   <tr key={customer.customerCode || index} className={styles.tr}>
//                     <td 
//                       className={`${styles.td} ${styles.clickableCell}`}
//                       onClick={() => handleCustomerClick(customer.customerCode)}
//                       title="Click to view details"
//                     >
//                       {customer.customerCode}
//                     </td>
//                     <td className={styles.td}>{customer.customerName}</td>
//                     <td className={styles.td}>{customer.phone || 'N/A'}</td>
//                     <td className={styles.td}>{customer.email || 'N/A'}</td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr className={styles.tr}>
//                   <td className={styles.td} colSpan="4" style={{ textAlign: 'center', padding: '40px' }}>
//                     No customers found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Mobile Card View */}
//       <div className={styles.mobileCardContainer}>
//         {loading ? (
//           <div className={styles.loadingCard}>
//             <div className={styles.loadingSpinner}>Loading...</div>
//           </div>
//         ) : customers.length > 0 ? (
//           customers.map((customer, index) => (
//             <div key={customer.customerCode || index} className={styles.customerCard}>
//               <div className={styles.cardHeader}>
//                 <h3 
//                   className={styles.cardTitle}
//                   onClick={() => handleCustomerClick(customer.customerCode)}
//                   title="Click to view details"
//                 >
//                   {customer.customerCode}
//                 </h3>
//               </div>
//               <div className={styles.cardBody}>
//                 <div className={styles.cardRow}>
//                   <span className={styles.cardLabel}>Customer Name</span>
//                   <span className={styles.cardValue}>{customer.customerName}</span>
//                 </div>
//                 <div className={styles.cardRow}>
//                   <span className={styles.cardLabel}>Phone</span>
//                   <span className={styles.cardValue}>{customer.phone || 'N/A'}</span>
//                 </div>
//                 <div className={styles.cardRow}>
//                   <span className={styles.cardLabel}>Email</span>
//                   <span className={styles.cardValue}>{customer.email || 'N/A'}</span>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className={styles.emptyCard}>No customers found</div>
//         )}
//       </div>

//       {/* Pagination */}
//       {!loading && customers.length > 0 && (
//         <div className={styles.paginationSection}>
//           <div className={styles.paginationInfo}>
//             Page {currentPage} of {totalPages} ({totalItems} total)
//           </div>
//           <div className={styles.paginationControls}>
//             <button 
//               className={styles.paginationButton}
//               onClick={() => setCurrentPage(1)} 
//               disabled={currentPage === 1}
//             >
//               First
//             </button>
//             <button 
//               className={styles.paginationButton}
//               onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))} 
//               disabled={currentPage === 1}
//             >
//               Prev
//             </button>
//             <div className={styles.pageNumber}>{currentPage}</div>
//             <button 
//               className={styles.paginationButton}
//               onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))} 
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//             <button 
//               className={styles.paginationButton}
//               onClick={() => setCurrentPage(totalPages)} 
//               disabled={currentPage === totalPages}
//             >
//               Last
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomerTable;

import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { customerApi } from '../../../../api/customer/customerApi';
import styles from './CustomerTable.module.css';

const CustomerTable = ({ onCustomerClick, savedState }) => {
  const [customers, setCustomers]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);
  const [searchTerm, setSearchTerm] = useState(savedState?.searchTerm || '');
  const [currentPage, setCurrentPage] = useState(savedState?.currentPage || 1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 20;

  const getCurrentTableState = () => ({ currentPage, searchTerm });

  const handleCustomerClick = (customerCode) => {
    if (onCustomerClick) onCustomerClick(customerCode, getCurrentTableState());
  };

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await customerApi.getCustomers(currentPage - 1, itemsPerPage, searchTerm);
      setCustomers(data.customers);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch customers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCustomers(); }, [currentPage, searchTerm]);

  const handleSearch   = () => { setCurrentPage(1); fetchCustomers(); };
  const handleClearFilters = () => { setSearchTerm(''); setCurrentPage(1); };

  const handleExportExcel = async () => {
    try {
      setLoading(true);
      const exportData = await customerApi.exportCustomers(searchTerm);
      const worksheet = XLSX.utils.json_to_sheet(exportData.map(c => ({
        'Customer Code':   c.customerCode,
        'Customer Name':   c.customerName,
        'City':            c.city       || 'N/A',
        'State':           c.state      || 'N/A',
        'Country':         c.country    || 'N/A',
        'Sales Employee':  c.salesEmployeeName || 'N/A',
        'Phone':           c.phone      || 'N/A',
        'Email':           c.email      || 'N/A',
      })));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Customers');
      XLSX.writeFile(workbook, `customers_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (err) {
      setError('Failed to export customers');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.filtersSection}>
        <div className={styles.searchRow}>
          <div className={styles.searchInputWrapper}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Search customers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            />
          </div>
          <button className={styles.searchButton} onClick={handleSearch} disabled={loading}>
            {loading ? 'Searching...' : 'Search'}
          </button>
        </div>
        <div className={styles.filterRow}>
          <div className={styles.actionButtons}>
            <button className={styles.clearButton} onClick={handleClearFilters} disabled={loading}>
              Clear Filters
            </button>
            <button className={styles.excelButton} onClick={handleExportExcel} disabled={loading}>
              <span className={styles.excelIcon}>📊</span> Export Excel
            </button>
          </div>
        </div>
      </div>

      {error && <div className={styles.errorMessage}><span>⚠️</span> {error}</div>}

      {/* Desktop Table */}
      <div className={styles.desktopTableContainer}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.th}>Customer Code</th>
                <th className={styles.th}>Customer Name</th>
                <th className={styles.th}>City</th>
                <th className={styles.th}>State</th>
                <th className={styles.th}>Country</th>
                <th className={styles.th}>Sales Employee</th>
                <th className={styles.th}>Phone</th>
                <th className={styles.th}>Email</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                  <div className={styles.loadingSpinner} />
                </td></tr>
              ) : customers.length > 0 ? (
                customers.map((c, i) => (
                  <tr key={c.customerCode || i} className={styles.tr}>
                    <td
                      className={`${styles.td} ${styles.clickableCell}`}
                      onClick={() => handleCustomerClick(c.customerCode)}
                    >
                      {c.customerCode}
                    </td>
                    <td className={styles.td}>{c.customerName}</td>
                    <td className={styles.td}>{c.city            || 'N/A'}</td>
                    <td className={styles.td}>{c.state           || 'N/A'}</td>
                    <td className={styles.td}>{c.country         || 'N/A'}</td>
                    <td className={styles.td}>{c.salesEmployeeName || 'N/A'}</td>
                    <td className={styles.td}>{c.phone           || 'N/A'}</td>
                    <td className={styles.td}>{c.email           || 'N/A'}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="8" style={{ textAlign: 'center', padding: '40px' }}>
                  No customers found
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Cards */}
      <div className={styles.mobileCardContainer}>
        {loading ? (
          <div className={styles.loadingCard}><div className={styles.loadingSpinner} /></div>
        ) : customers.length > 0 ? (
          customers.map((c, i) => (
            <div key={c.customerCode || i} className={styles.customerCard}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle} onClick={() => handleCustomerClick(c.customerCode)}>
                  {c.customerCode}
                </h3>
              </div>
              <div className={styles.cardBody}>
                {[
                  ['Customer Name',  c.customerName],
                  ['City',           c.city],
                  ['State',          c.state],
                  ['Country',        c.country],
                  ['Sales Employee', c.salesEmployeeName],
                  ['Phone',          c.phone],
                  ['Email',          c.email],
                ].map(([label, val]) => (
                  <div key={label} className={styles.cardRow}>
                    <span className={styles.cardLabel}>{label}</span>
                    <span className={styles.cardValue}>{val || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div className={styles.emptyCard}>No customers found</div>
        )}
      </div>

      {/* Pagination */}
      {!loading && customers.length > 0 && (
        <div className={styles.paginationSection}>
          <div className={styles.paginationInfo}>
            Page {currentPage} of {totalPages} ({totalItems} total)
          </div>
          <div className={styles.paginationControls}>
            {[['First', 1], ['Prev', currentPage - 1]].map(([label, page]) => (
              <button key={label} className={styles.paginationButton}
                onClick={() => setCurrentPage(Math.max(1, page))}
                disabled={currentPage === 1}>{label}</button>
            ))}
            <div className={styles.pageNumber}>{currentPage}</div>
            {[['Next', currentPage + 1], ['Last', totalPages]].map(([label, page]) => (
              <button key={label} className={styles.paginationButton}
                onClick={() => setCurrentPage(Math.min(totalPages, page))}
                disabled={currentPage === totalPages}>{label}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerTable;